import { render } from "./ImageCarousel.vue?vue&type=template&id=31dd175b&scoped=true&lang=html"
import script from "./ImageCarousel.vue?vue&type=script&lang=js"
export * from "./ImageCarousel.vue?vue&type=script&lang=js"

import "./ImageCarousel.vue?vue&type=style&index=0&id=31dd175b&lang=css&scoped=true"

import exportComponent from "/Users/peterdevos/Sites/sephendevos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31dd175b"]])

export default __exports__